"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ApiProvider = void 0;
var _auth = require("@ori/auth");
var _configurationManager = require("@ori/configuration-manager");
var _environment = require("@ori/environment");
var _fetching = require("@ori/fetching");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _i18n = require("@ori/i18n");
var _presentationUtils = require("@ori/presentation-utils");
var _jsxRuntime = require("react/jsx-runtime");
const ApiProvider = ({
  children
}) => {
  const {
    language
  } = (0, _i18n.useLanguage)();
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    globalApiUrl
  } = (0, _configurationManager.useServiceUrls)(['globalApi']);
  const {
    token
  } = (0, _auth.useToken)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_fetching.SWRConfig, {
    value: (0, _presentationUtils.getRetryErrorSwrOptions)(),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_globalApiClientReact.ApiClientProvider, {
      baseUrl: globalApiUrl,
      language: language,
      tenant: tenant,
      token: token,
      children: children
    })
  });
};
exports.ApiProvider = ApiProvider;
